// extracted by mini-css-extract-plugin
export default {"th":"Th_th__P3zUS","control":"Th_control__JsZ9h","icon":"Th_icon__Yk8sc"};